<template>
  <div class="action-config-item automate-config">
    <div class="mb-4">
      <label for="action-name" class="block text-sm font-semibold text-gray-700">Action Name</label>
      <el-input
        v-model="localStep.label"
        id="action-name"
        placeholder="Enter Action Name"
        clearable
        class="w-full rounded-md"
      />
    </div>
    <el-button
      type="primary"
      icon="el-icon-s-tools"
      class="automate-config-btn"
      @click="openAutomateDrawer()"
    >
      Configure
    </el-button>

    <AutomationConfigureBlock
      v-if="configAutomateModel"
      :isOpen="configAutomateModel"
      :allFields="allFields"
      :step="localStep"
      :automationRules="automationRules"
      :automationRulesType="rulesType"
      @saveAutomationRules="saveAutomation"
      @deleteAutomationRule="deleteAutomationRule"
    />
    <!-- Footer Actions -->
    <div class="automation-footer-actions mt-4 flex justify-end gap-2">
      <el-button @click="cancelChanges">Cancel</el-button>
      <el-button type="primary" @click="saveChanges">Save</el-button>
    </div>
  </div>
</template>

<script>
  import StepEditableMixin from './StepEditableMixin';
  export default {
    name: 'AutomateAction',
    props: {
      step: Object,
      allFields: Array,
    },
    mixins: [StepEditableMixin],
    components: {
      AutomationConfigureBlock: () => import('@/components/entity/EntityAutomationBlock.vue'),
    },
    data() {
      return {
        automationRules: [],
        automationRulesType: true,
        rulesType: true,
        configAutomateModel: false,
      };
    },
    methods: {
      openAutomateDrawer() {
        if (this.localStep?.automation_rules) {
          this.automationRules = this.localStep.automation_rules;
          this.rulesType = this.localStep.automationRulesType;
        }
        this.configAutomateModel = true;
      },
      saveAutomation(type, rules) {
        this.automationRulesType = type;
        this.automationRules = rules;
        this.saveAutomationHelper();
      },
      saveAutomationHelper() {
        this.$set(this.localStep, 'automation_rules', this.automationRules);
        this.$set(this.localStep, 'automationRulesType', this.automationRulesType);
        this.resetAutomationRules();
      },
      resetAutomationRules() {
        this.automationRules = [];
        this.automationRulesType = true;
        this.configAutomateModel = false;
      },
      deleteAutomationRule(rules) {
        this.automationRules = rules;
      },
    },
  };
</script>

<style scoped>
  .automate-config {
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }

  .automate-config-btn {
    align-self: flex-start;
    font-weight: 500;
    border-radius: 6px;
    padding: 0.5rem 1rem;
    transition: background-color 0.2s ease;
  }

  .automate-config-btn:hover {
    background-color: #409eff;
    color: #fff;
  }

  .action-config-item {
    padding: 1rem 0;
  }

  /* Utility spacing & layout */
  .d-flex {
    display: flex;
  }
  .gap-1 {
    gap: 0.5rem;
  }
  .mt-1 {
    margin-top: 0.5rem;
  }
</style>
